import React, { Fragment, useEffect, useState } from "react";
import { translate } from "react-switch-lang";
import { Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import Header from "../header/header";
import Taptop from "../template/tap-top";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import styles from "./statistic.module.scss";
import { Chart } from "react-google-charts";
import About from "../home/about/about";
import Footer from "../template/footer";
import { useHttpClient } from "../../security/hooks/axiosProvider";
import { StatisticDataDto } from "../../models/statisticDataDto";
import { StatisticGroup } from "../../models/statisticGroup";
import { ACTION } from "../../models/action";
import { StatisticGroupDto } from "../../models/StatisticGroupDto";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Home as IconHome } from "react-feather";

const Statistic: React.FC<{ t: (key: string) => {} }> = props => {
  const httpClient = useHttpClient(true);
  const [statisticData, setStatisticData] = useState(new StatisticDataDto());
  const [searchDate] = useState<any>(new Date().getFullYear());
  const monthNamesEn = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const monthNamesFr = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"];
  const [statisticDocumentView, setStatisticDocumentView] = useState<StatisticGroupDto[]>([]);
  const [statisticDocumentDownload, setStatisticDocumentDownload] = useState<StatisticGroupDto[]>([]);
  const [statisticVideoView, setStatisticVideoView] = useState<StatisticGroupDto[]>([]);
  const [statisticExpositionView, setStatisticExpositionView] = useState<StatisticGroupDto[]>([]);
  const [statisticVisitorView, setStatisticVisitorView] = useState<StatisticGroupDto[]>([]);
  const [listChartDocument, setListChartDocument] = useState<any[][]>([[props.t("statistic.label_month"), props.t("statistic.label_view"), props.t("statistic.label_download")]]);
  const [listChartVideo, setListChartVideo] = useState<any[][]>([[props.t("statistic.label_month"), props.t("statistic.label_view")]]);
  const [listChartExposition, setListChartExposition] = useState<any[][]>([[props.t("statistic.label_month"), props.t("statistic.label_view")]]);
  const [listChartVisitor, setListChartVisitor] = useState<any[][]>([[props.t("statistic.label_month"), props.t("statistic.label_view")]]);
  const [listChartDocumentYear] = useState<any[][]>([
    [props.t("statistic.label_month"), props.t("statistic.label_view"), props.t("statistic.label_download")],
    ["2021", 1, 2],
  ]);
  const [chartDocumentselect, setChartDocumentselect] = useState("Month");
  const [chartVideoselect, setChartVideoselect] = useState("Month");
  const [chartExpositionselect, setChartExpositionselect] = useState("Month");
  const [chartVisitorselect, setChartVisitorselect] = useState("Month");
  const [, setListYearRange] = useState([]);
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  useEffect(() => {
    setListChartDocument(
      chartDocumentselect === "Month"
        ? [[props.t("statistic.label_month"), props.t("statistic.label_view"), props.t("statistic.label_download")]]
        : [[props.t("statistic.label_year"), props.t("statistic.label_view"), props.t("statistic.label_download")]],
    );
    let childList = [];
    httpClient.current?.get("/statistic_media/percentage").then(response => {
      setStatisticData(response.data);
    });
    httpClient.current
      .get("/statistic_media", {
        params: {
          groupBy: StatisticGroup.MONTH,
          year: searchDate,
          typeCategory: "0",
          action: ACTION.VIEW,
        },
      })
      .then(response => {
        httpClient.current
          .get("/statistic_media", {
            params: {
              groupBy: StatisticGroup.MONTH,
              year: searchDate,
              typeCategory: "0",
              action: ACTION.DOWNLOAD,
            },
          })
          .then(res => {
            monthNamesEn.forEach((month: string, index: number) => {
              childList = [];
              childList.push(month);
              if (response.data.filter((element: StatisticGroupDto) => element.month === index + 1).length === 1) {
                childList.push(+response.data.filter((element: StatisticGroupDto) => element.month === index + 1)[0].count);
              } else {
                childList.push(0);
              }

              if (res.data.filter((element: StatisticGroupDto) => element.month === index + 1).length === 1) {
                childList.push(+res.data.filter((element: StatisticGroupDto) => element.month === index + 1)[0].count);
                listChartDocument.push(childList);
                setListChartDocument(listChartDocument);
                listChartDocument.forEach((element: any, index: number) => {
                  if (index !== 0) {
                    element[0] = monthNamesFr[index - 1];
                  }
                });
              } else {
                childList.push(0);
                listChartDocument.push(childList);
                setListChartDocument(listChartDocument);
                listChartDocument.forEach((element: any, index: number) => {
                  if (index !== 0) {
                    element[0] = monthNamesFr[index - 1];
                  }
                });
              }
            });
          });
      });
    httpClient.current
      ?.get("/statistic_media", {
        params: {
          groupBy: StatisticGroup.MONTH,
          year: new Date().getFullYear(),
          typeCategory: "1",
          action: ACTION.VIEW,
        },
      })
      .then(response => {
        let childList = [];
        monthNamesEn.forEach((month: string, index: number) => {
          childList = [];
          childList.push(month);
          if (response.data.filter((element: StatisticGroupDto) => element.month === index + 1).length === 1) {
            childList.push(response.data.filter((element: StatisticGroupDto) => element.month === index + 1)[0].count);
            listChartVideo.push(childList);
            setListChartVideo(listChartVideo);
          } else {
            childList.push(0);
            listChartVideo.push(childList);
            setListChartVideo(listChartVideo);
          }
        });
      });
    httpClient.current
      ?.get("/statistic_media", {
        params: {
          groupBy: StatisticGroup.MONTH,
          year: new Date().getFullYear(),
          typeCategory: "2",
          action: ACTION.VIEW,
        },
      })
      .then(response => {
        let childList = [];
        monthNamesEn.forEach((month: string, index: number) => {
          childList = [];
          childList.push(month);
          if (response.data.filter((element: StatisticGroupDto) => element.month === index + 1).length === 1) {
            childList.push(response.data.filter((element: StatisticGroupDto) => element.month === index + 1)[0].count);
            listChartExposition.push(childList);
            setListChartExposition(listChartExposition);
          } else {
            childList.push(0);
            listChartExposition.push(childList);
            setListChartExposition(listChartExposition);
          }
        });
      });

    httpClient.current
      ?.get("/statistic_visitor", {
        params: {
          groupBy: StatisticGroup.MONTH,
          year: new Date().getFullYear(),
        },
      })
      .then(response => {
        let childList = [];
        monthNamesEn.forEach((month: string, index: number) => {
          childList = [];
          childList.push(month);
          if (response.data.filter((element: StatisticGroupDto) => element.month === index + 1).length === 1) {
            childList.push(response.data.filter((element: StatisticGroupDto) => element.month === index + 1)[0].count);
            listChartVisitor.push(childList);
            setListChartVisitor(listChartVisitor);
          } else {
            childList.push(0);
            listChartVisitor.push(childList);
            setListChartVisitor(listChartVisitor);
          }
        });
      });
    handleGetStatisticDataDocument("month", "0");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [httpClient]);

  const handleChangeMonthName = (list, num) => {
    list.forEach(function (element: any, index: number) {
      if (index !== 0) {
        selectedLanguage === "en" ? (element[0] = monthNamesEn[index - 1]) : (element[0] = monthNamesFr[index - 1]);
      } else {
        if (+num === 0) {
          element[0] = props.t("statistic.label_month");
          element[1] = props.t("statistic.label_view");
          element[2] = props.t("statistic.label_download");
        } else if (+num === 4) {
          element[0] = props.t("statistic.label_month");
          element[1] = props.t("statistic.label_visitor");
        } else {
          element[0] = props.t("statistic.label_month");
          element[1] = props.t("statistic.label_view");
        }
      }
    });
    return list;
  };
  const handleGetStatisticDataDocument = (group: string, typeCategory: string) => {
    listChartDocumentYear.splice(0, listChartDocumentYear.length);
    if (chartDocumentselect === "Month") {
      listChartDocumentYear.push([props.t("statistic.label_month"), props.t("statistic.label_view"), props.t("statistic.label_download")]);
    } else {
      listChartDocumentYear.push([props.t("statistic.label_year"), props.t("statistic.label_view"), props.t("statistic.label_download")]);
    }
    httpClient.current
      ?.get("/statistic_media", {
        params: {
          groupBy: group.toLowerCase(),
          year: searchDate,
          typeCategory: "0",
          action: ACTION.VIEW,
        },
      })
      .then(response => {
        setStatisticDocumentView(response.data);
        httpClient.current
          ?.get("/statistic_media", {
            params: {
              groupBy: group.toLowerCase(),
              year: searchDate,
              typeCategory: "0",
              action: ACTION.DOWNLOAD,
            },
          })
          .then(res => {
            setStatisticDocumentDownload(res.data);
            setListYearRange(generateArrayOfYears(Math.min(...response.data.map(element => +element.year).concat(...res.data.map(element => +element.year)))));
          });
      });
  };

  const handleGetStatisticDataVideo = (group: string, typeCategory: string) => {
    listChartDocumentYear.splice(0, listChartDocumentYear.length);
    listChartDocumentYear.push([props.t("statistic.label_year"), props.t("statistic.label_view")]);
    httpClient.current
      ?.get("/statistic_media", {
        params: {
          groupBy: StatisticGroup.YEAR,
          year: new Date().getFullYear(),
          typeCategory: "1",
          action: ACTION.VIEW,
        },
      })
      .then(response => {
        setStatisticVideoView(response.data);
        setListYearRange(generateArrayOfYears(Math.min(...response.data.map(element => +element.year))));
      });
  };

  const handleGetStatisticDataExposition = (group: string, typeCategory: string) => {
    httpClient.current
      ?.get("/statistic_media", {
        params: {
          groupBy: StatisticGroup.YEAR,
          year: new Date().getFullYear(),
          typeCategory: "2",
          action: ACTION.VIEW,
        },
      })
      .then(response => {
        setStatisticExpositionView(response.data);
      });
  };

  const handleGetStatisticDataVisitor = () => {
    httpClient.current
      ?.get("/statistic_visitor", {
        params: {
          groupBy: StatisticGroup.YEAR,
          year: new Date().getFullYear(),
        },
      })
      .then(response => {
        setStatisticVisitorView(response.data);
      });
  };

  const handleGetListStatisticVideoGroupByYear = () => {
    let list = [[props.t("statistic.label_year"), props.t("statistic.label_view")]];
    let childList = [];
    generateArrayOfYears(Math.min(...statisticVideoView.map(element => +element.year))).forEach((year, index) => {
      childList = [];
      childList.push(year);
      if (statisticVideoView.filter((element: StatisticGroupDto) => +element.year === +year).length === 1) {
        childList.push(statisticVideoView.filter((element: StatisticGroupDto) => +element.year === +year)[0].count);
        list.push(childList);
      } else {
        childList.push(0);
        list.push(childList);
      }
    });
    return list;
  };

  const handleGetListStatisticExpositionGroupByYear = () => {
    let list = [[props.t("statistic.label_year"), props.t("statistic.label_view")]];
    let childList = [];
    generateArrayOfYears(Math.min(...statisticExpositionView.map(element => +element.year))).forEach((year, index) => {
      childList = [];
      childList.push(year);
      if (statisticExpositionView.filter((element: StatisticGroupDto) => +element.year === +year).length === 1) {
        childList.push(statisticExpositionView.filter((element: StatisticGroupDto) => +element.year === +year)[0].count);
        list.push(childList);
      } else {
        childList.push(0);
        list.push(childList);
      }
    });
    return list;
  };

  const handleGetListStatisticVisitorGroupByYear = () => {
    let list = [[props.t("statistic.label_year"), props.t("statistic.label_visitor")]];
    let childList = [];
    generateArrayOfYears(Math.min(...statisticVisitorView.map(element => +element.year))).forEach((year, index) => {
      childList = [];
      childList.push(year);
      if (statisticVisitorView.filter((element: StatisticGroupDto) => +element.year === +year).length === 1) {
        childList.push(statisticVisitorView.filter((element: StatisticGroupDto) => +element.year === +year)[0].count);
        list.push(childList);
      } else {
        childList.push(0);
        list.push(childList);
      }
    });
    return list;
  };

  const handleGetListStatisticDocumentGroupByYear = () => {
    let list = [[props.t("statistic.label_year"), props.t("statistic.label_view"), props.t("statistic.label_download")]];
    let childList = [];
    generateArrayOfYears(Math.min(...statisticDocumentView.map(element => +element.year).concat(statisticDocumentDownload.map(element => +element.year)))).forEach((year, index) => {
      childList = [];
      childList.push(year);
      if (statisticDocumentView.filter((element: StatisticGroupDto) => +element.year === +year).length === 1) {
        childList.push(statisticDocumentView.filter((element: StatisticGroupDto) => +element.year === +year)[0].count);
      } else {
        childList.push(0);
      }

      if (statisticDocumentDownload.filter((element: StatisticGroupDto) => +element.year === +year).length === 1) {
        childList.push(statisticDocumentDownload.filter((element: StatisticGroupDto) => +element.year === +year)[0].count);
        listChartDocumentYear.push(childList);
        list.push(childList);
      } else {
        childList.push(0);
        listChartDocumentYear.push(childList);
        list.push(childList);
      }
    });
    return list;
  };

  const generateArrayOfYears = (min: number) => {
    let max = new Date().getFullYear();
    let years = [];

    for (let i = min; i <= max; i++) {
      years.push(String(i));
    }
    return years;
  };

  return (
    <Fragment>
      <Taptop />
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <Header></Header>
        <div className={`page-body-wrapper`}>
          <div className={`m-l-0 page-body`}>
            <Container className="search-page" fluid>
              <div className={styles["statistic_page-title"] + " page-title"}>
                <Row>
                  <Col xs="6">
                    <Breadcrumb>
                      <BreadcrumbItem>
                        <Link to={`/`}>
                          <IconHome />
                        </Link>
                      </BreadcrumbItem>
                      <BreadcrumbItem active>{props.t("title_statistic")}</BreadcrumbItem>
                    </Breadcrumb>
                  </Col>
                </Row>
              </div>
            </Container>

            <Container fluid className="m-t-20">
              <Col xl="9 xl-100" className="chart_data_left box-col-12 p-l-0 p-r-0">
                <Card>
                  <CardBody className="p-0">
                    <Row className="m-0 chart-main">
                      <Col xl="4" md="6" sm="12" className={styles["box-circle-progress-chart"] + " text-center p-0 box-col-4"}>
                        <Row className={styles["row"]}>
                          <div className={styles["circle-progress-chart"] + " p-20"}>
                            <CircularProgressbar
                              value={statisticData.numberDocument}
                              maxValue={statisticData.total}
                              text={`${((100 / statisticData.total) * statisticData.numberDocument).toFixed(2)}%`}
                            />
                          </div>
                          <h5 className={styles["title-circle-progress-chart"] + " text-center"}>{props.t("statistic.label_document") + "(" + statisticData.numberDocument + ")"}</h5>
                        </Row>
                      </Col>
                      <Col xl="4" md="6" sm="12" className={styles["box-circle-progress-chart"] + " text-center p-0 box-col-4"}>
                        <Row className={styles["row"]}>
                          <div className={styles["circle-progress-chart"] + " p-20"}>
                            <CircularProgressbar value={statisticData.numberVideo} maxValue={statisticData.total} text={`${((100 / statisticData.total) * statisticData.numberVideo).toFixed(2)}%`} />
                          </div>
                          <h5 className={styles["title-circle-progress-chart"] + " text-center"}>{props.t("statistic.label_video") + "(" + statisticData.numberVideo + ")"}</h5>
                        </Row>
                      </Col>
                      <Col xl="4" md="6" sm="12" className={styles["exposition-box-circle-progress-chart"] + " text-center p-0 box-col-4"}>
                        <Row className={styles["row"]}>
                          <div className={styles["circle-progress-chart"] + " p-20"}>
                            <CircularProgressbar
                              value={statisticData.numberExposition}
                              maxValue={statisticData.total}
                              text={`${((100 / statisticData.total) * statisticData.numberExposition).toFixed(2)}%`}
                            />
                          </div>
                          <h5 className={styles["title-circle-progress-chart"] + " text-center"}>{props.t("statistic.label_exposition") + "(" + statisticData.numberExposition + ")"}</h5>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Row className="m-b-20 float">
                <Col md={3}></Col>
                <Col md={3}></Col>
                <Col md={3}></Col>
                <Col md={3}></Col>
              </Row>
              <Row>
                <Col xl="4 xl-50" className="appointment box-col-6">
                  <Card>
                    <CardHeader>
                      <div className="header-top">
                        <h5 className="m-0">{props.t("statistic.label_attendance")}</h5>
                        <div className="card-header-right-icon">
                          <select
                            onChange={event => {
                              setChartVisitorselect(event.target.value);
                              handleGetStatisticDataVisitor();
                            }}
                            className={styles["card-statistic-document-select"] + " button btn btn"}
                          >
                            <option value="Month">{props.t("statistic.label_month")}</option>
                            <option value="Year">{props.t("statistic.label_year")}</option>
                          </select>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <Chart
                        width={"100%"}
                        height={"300px"}
                        chartType="ColumnChart"
                        loader={<div>Loading Chart</div>}
                        data={chartVisitorselect === "Month" ? handleChangeMonthName(listChartVisitor, "4") : handleGetListStatisticVisitorGroupByYear()}
                        options={{
                          legend: { position: "top" },
                        }}
                        rootProps={{ "data-testid": "4" }}
                      />
                    </CardBody>
                  </Card>
                </Col>
                <Col xl="4 xl-50" className="appointment box-col-6">
                  <Card>
                    <CardHeader>
                      <div className="header-top">
                        <h5 className="m-0">{props.t("statistic.label_document")}</h5>
                        <div className="card-header-right-icon">
                          <select
                            onChange={event => {
                              setChartDocumentselect(event.target.value);
                              handleGetStatisticDataDocument(event.target.value, "0");
                            }}
                            className={styles["card-statistic-document-select"] + " button btn btn"}
                          >
                            <option value="Month">{props.t("statistic.label_month")}</option>
                            <option value="Year">{props.t("statistic.label_year")}</option>
                          </select>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <Chart
                        width={"100%"}
                        height={"300px"}
                        chartType="ColumnChart"
                        loader={<div>Loading Chart</div>}
                        data={chartDocumentselect === "Month" ? handleChangeMonthName(listChartDocument, "0") : handleGetListStatisticDocumentGroupByYear()}
                        options={{
                          legend: { position: "top" },
                        }}
                        rootProps={{ "data-testid": "1" }}
                      />
                    </CardBody>
                  </Card>
                </Col>
                <Col xl="4 xl-50" className="appointment box-col-6">
                  <Card>
                    <CardHeader>
                      <div className="header-top">
                        <h5 className="m-0">{props.t("statistic.label_video")}</h5>
                        <div className="card-header-right-icon">
                          <select
                            onChange={event => {
                              setChartVideoselect(event.target.value);
                              handleGetStatisticDataVideo(event.target.value, "1");
                            }}
                            className={styles["card-statistic-document-select"] + " button btn btn"}
                          >
                            <option value="Month">{props.t("statistic.label_month")}</option>
                            <option value="Year">{props.t("statistic.label_year")}</option>
                          </select>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <Chart
                        width={"100%"}
                        height={"300px"}
                        chartType="ColumnChart"
                        loader={<div>Loading Chart</div>}
                        data={chartVideoselect === "Month" ? handleChangeMonthName(listChartVideo, "1") : handleGetListStatisticVideoGroupByYear()}
                        options={{
                          legend: { position: "top" },
                        }}
                        rootProps={{ "data-testid": "4" }}
                      />
                    </CardBody>
                  </Card>
                </Col>
                <Col xl="4 xl-50" className="appointment box-col-6">
                  <Card>
                    <CardHeader>
                      <div className="header-top">
                        <h5 className="m-0">{props.t("statistic.label_exposition")}</h5>
                        <div className="card-header-right-icon">
                          <select
                            onChange={event => {
                              setChartExpositionselect(event.target.value);
                              handleGetStatisticDataExposition(event.target.value, "2");
                            }}
                            className={styles["card-statistic-document-select"] + " button btn btn"}
                          >
                            <option value="Month">{props.t("statistic.label_month")}</option>
                            <option value="Year">{props.t("statistic.label_year")}</option>
                          </select>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <Chart
                        width={"100%"}
                        height={"300px"}
                        chartType="ColumnChart"
                        loader={<div>Loading Chart</div>}
                        data={chartExpositionselect === "Month" ? handleChangeMonthName(listChartExposition, "2") : handleGetListStatisticExpositionGroupByYear()}
                        options={{
                          legend: { position: "top" },
                        }}
                        rootProps={{ "data-testid": "4" }}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
          <About />
          <Footer />
        </div>
      </div>
    </Fragment>
  );
};

export default translate(Statistic);
